import { useAtomValue } from "jotai";
import { Alert, AlertDescription, Button } from "@zapier/design-system";
import {
  AssetType,
  capitalizedAssetTypeDisplayAtom,
} from "@zapier/canvas-state";
import styles from "./LinkRemovalWarning.module.css";

type Props = {
  onConfirm: () => void;
  onDismiss: () => void;
  assetType: NonNullable<AssetType>;
};

export function LinkRemovalWarning({ onConfirm, onDismiss, assetType }: Props) {
  const getAssetDisplayName = useAtomValue(capitalizedAssetTypeDisplayAtom);
  const capitalizedAssetType = getAssetDisplayName(assetType);

  const article =
    assetType === "interface" || assetType === "agent" ? "an" : "a";

  return (
    <div className={styles.root}>
      <Alert
        onDismiss={onDismiss}
        status="warning"
        title={`Changing to ${article} ${capitalizedAssetType} will remove the link from this step.`}
      >
        <AlertDescription>Do you wish to continue?</AlertDescription>
        <div className={styles.buttonWrapper}>
          <Button variant="tertiary" size="small" onPress={onDismiss}>
            Cancel
          </Button>
          <Button variant="primary" size="small" onPress={onConfirm}>
            Confirm
          </Button>
        </div>
      </Alert>
    </div>
  );
}
